import * as TYPES from './types';
import { api } from '@lib/http';

export function notifySetAlert(name, value) {
    return {
        payload: {
            name,
            value,
        },
        type: TYPES.NOTIFY_ALERT_SET_ITEMS,
    };
}

export async function refreshNotifyAlerts(dispatch) {
    const alert = await api.get('/apparel-notifications', {
        params: {
            return_only: 'id',
        },
    });
    dispatch(notifySetAlert('unread_notification_count', alert.data?.unread));
    dispatch(notifySetAlert('notification_count', alert.data?.total));
}
